$.ready(function() { 

	var hider = $.div().addClass('hider').prependTo(game);
	
	game.features.freespin.on('init',function() {
		hider.addClass('show');
	});	
	game.features.freespin.on('finish',function() {
		hider.removeClass('show');
	});
	
});


/** WEBPACK FOOTER **
 ** ./public-src/js/bg_hider.js
 **/